'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _adjudicators = require('ifeis-isomorphic/lib/redux/actions/adjudicators');

var _feiseanna = require('ifeis-isomorphic/lib/redux/actions/feiseanna');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JudgesReportsController = function () {
  function JudgesReportsController($q, feis, events, fRouterHistoryService, fPrint, msgService, $filter, fFeisService, $ngRedux) {
    _classCallCheck(this, JudgesReportsController);

    this.$q = $q;
    this.feis = feis;
    this.events = events;
    this.fRouterHistoryService = fRouterHistoryService;
    this.fPrint = fPrint;
    this.msgService = msgService;
    this.scoresheetsForSelected = [];
    this.isLoading = false;
    this.loadEvents();
    this.$filter = $filter;
    this.reportSource = true;
    this.$ngRedux = $ngRedux;
  }

  // Load all events in results, recall, and QA. This does not generate the report; the user selects
  // events from this list to include in the report.


  _createClass(JudgesReportsController, [{
    key: 'loadEvents',
    value: function loadEvents() {
      var _this = this;

      this.isLoading = true;
      var resChampionshipPromise = this.events.all({ type: 'C', status: 'RES' });
      var rclChampionshipPromise = this.events.all({ type: 'C', status: 'RCL' });
      var qaChampionshipPromise = this.events.all({ type: 'C', status: 'QA' });
      this.$q.all([resChampionshipPromise, rclChampionshipPromise, qaChampionshipPromise]).then(function (e) {
        return _this.eventsWithResults = e.reduce(function (allEvents, event) {
          return allEvents.concat(event);
        }, []);
      }).catch(function (e) {
        return _this.msgService.displayErrorMsg(e.message || e.toString());
      }).finally(function () {
        return _this.isLoading = false;
      });
    }

    // Given an event, fetch its adjudicators and scores, calculate the computed values,
    // and store it for subsequent inclusion in the report.

  }, {
    key: 'loadReportDataForSelectedEvent',
    value: function loadReportDataForSelectedEvent(rowIndex) {
      var _this2 = this;

      var event = this.eventsWithResults[rowIndex];
      if (event.selectedItem === 1) {
        this.scoresheetsForSelected = this.scoresheetsForSelected.filter(function (eventInArray) {
          return eventInArray.event.id !== event.id;
        });
        return;
      }
      this.scoreCalculator = new _ifeisIsomorphic.ScoreCalculator(event, []);
      this.isLoading = true;

      this.$q.all([this.events.adjudicators(event.id), this.events.participants(event.id)]).then(function (payload) {
        var adjs = payload[0];
        var participants = payload[1];
        _this2.isLoading = false;
        adjs.forEach(function (adjudicator) {
          _this2.loading = true;
          _this2.events.getScores(event.id, adjudicator.id).then(function (scores) {

            _this2.scoreCalculator.addScoresheet(scores);

            scores = scores.map(function (score) {
              var person = participants.find(function (person) {
                return person.id === score.person;
              });

              return _extends({}, score, {
                computedTotal: _this2.$filter('number')(score.computedTotal, 2),
                total: _this2.$filter('number')(score.total, 2),
                competitorName: person.fname + ' ' + person.lname,
                schoolName: person.school.name,
                overallPlacement: person.reg.placement,
                overallIrishPoints: _this2.$filter('number')(person.reg.computedTotal, 2),
                overallTotal: _this2.$filter('number')(person.reg.total, 2)
              });
            }).sort(function (x, y) {
              return y.total - x.total;
            });

            var sortedScoresForSummary = angular.copy(scores).sort(function (a, b) {
              return a.overallPlacement - b.overallPlacement;
            });

            _this2.scoresheetsForSelected.push({ event: event, adjudicator: adjudicator, scores: scores, sortedScoresForSummary: sortedScoresForSummary });
            _this2.isLoading = false;
          });
        });
        _this2.scoresheetsForSelected.push({ type: 'summary', event: event });
      }).catch(function (e) {
        _this2.msgService.displayErrorMsg(e.message || e.toString());
        _this2.isLoading = false;
      });
    }
  }, {
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'getDataForAdjudicator',
    value: function getDataForAdjudicator() {
      var _this3 = this;

      this.isLoading = true;
      this.$ngRedux.dispatch((0, _feiseanna.getEventsScoredByAdjudicators)(this.feis.id, this.adjudicator.id)).then(function (res) {
        _this3.scoresheetsForSelected = res.payload || [];
        _this3.isLoading = false;

        if (_this3.scoresheetsForSelected.length > 0) {
          _this3.generateReportPDF();
        } else {
          _this3.msgService.displayWarningMsg("No data for selected judge.");
        }
      }).catch(function (e) {
        _this3.msgService.displayErrorMsg(e.message || e.toString());
        _this3.isLoading = false;
      });
    }
  }, {
    key: 'generateReportPDF',
    value: function generateReportPDF() {
      var _this4 = this;

      var feisName = this.feis.name;
      var headlineSize = 20;
      var subheadSize = 14;
      var linesPerPage = 15;

      var _fPrint$metrics = this.fPrint.metrics(true),
          margin = _fPrint$metrics.margin,
          pageWidth = _fPrint$metrics.pageWidth,
          useablePageWidth = _fPrint$metrics.useablePageWidth;

      var positionY = void 0;
      var doc = this.fPrint.create(this.feis.slug + '_Judges-Report.pdf', { layout: 'landscape' });

      var addSummaryPage = function addSummaryPage(summaryArrayItem, scoresheets, persons, idxOfPage) {

        if (idxOfPage > 0) {
          doc.addPage();
        }

        // Showing feisName
        doc.fontSize(headlineSize);
        doc.text('' + feisName, 250, 20);
        positionY = margin;

        // Showing ifeis logo
        doc.image(_this4.logo, 10, 10, { width: 60 });

        doc.fontSize(12);
        doc.text((summaryArrayItem.event.description || '') + ' Judges Score Summary', margin, 60, {
          align: 'center',
          lineBreak: true,
          width: useablePageWidth,
          height: headlineSize,
          ellipsis: true
        });

        positionY += headlineSize + 30;

        doc.fontSize(11);

        var width = useablePageWidth;
        var height = 32;
        var tableStartY = positionY;
        var tableEndY = tableStartY + ((persons.length - 1) * height + 32);
        var positionX = margin;

        var cols = [{
          valueToGet: 'overallPlacement',
          label: 'Place',
          w: width * 0.1,
          align: 'center',
          fontSize: 11
        }, {
          valueToGet: 'competitor',
          label: 'Competitor',
          w: width * 0.3,
          align: 'center',
          fontSize: 11
        }];

        scoresheets.forEach(function (s, idx) {
          cols.push({
            valueToGet: idx,
            identifier: 'Judge',
            label: s.adjudicator.fname + ' ' + s.adjudicator.lname,
            w: width * (0.4 / scoresheets.length),
            align: 'center',
            fontSize: 11
          });
        });

        cols.push({
          valueToGet: 'overallTotal',
          label: 'Total',
          w: width * 0.1,
          align: 'center',
          fontSize: 11
        }, {
          valueToGet: 'overallIrishPoints',
          label: 'Irish Points',
          w: width * 0.1,
          align: 'center',
          fontSize: 11
        });

        // Calculate column starting positions
        cols.forEach(function (col) {
          col.x = positionX;
          positionX += col.w;
        });

        // Add end column line
        cols.push({ x: pageWidth - margin });

        doc.image(_this4.logo, 10, 10, { width: 60 });

        var _loop = function _loop(row) {
          // Draw row lines
          doc.moveTo(margin, positionY).lineTo(margin + width, positionY).stroke();

          var text = '';

          // Draw column lines
          cols.forEach(function (col) {
            doc.fontSize(col.fontSize || subheadSize);

            // Printing column labels. Since columns
            doc.text(col.label || '', col.x, tableStartY + (32 - subheadSize) / 2, {
              height: height,
              width: col.w,
              align: 'center',
              lineBreak: false,
              ellipsis: true
            });

            // Printing column values from data in each row
            if (row < persons.length) {
              if (/Judge/.test(col.identifier)) {
                // for summary, we slice the persons array to print 15 lines but then we need
                // to get the correct row from scoresheets for the persons item and thats why below math with
                // linesPerPage and current indexOfPage.
                var person = persons[row];
                var scoresheetToPrint = scoresheets[col.valueToGet].sortedScoresForSummary.find(function (scoresheetSummary) {
                  return scoresheetSummary.person === person.person;
                });
                text = scoresheetToPrint.placement + ' - ' + _this4.$filter('number')(scoresheetToPrint.computedTotal, 2) + ' \n (' + scoresheetToPrint.total + ')';
              } else if (/Competitor/.test(col.label)) {
                text = persons[row].competitor + ' ' + persons[row].competitorName;
              } else {
                text = col.valueToGet ? persons[row][col.valueToGet] : '';
              }
            } else {
              // Stroking column lines on last row
              doc.moveTo(col.x, tableStartY + 32).lineTo(col.x, tableEndY + 32).stroke();
            }

            // Writing data to report for each column and each row
            doc.moveTo(col.x, tableStartY).lineTo(col.x, tableEndY).stroke().text(text, col.x, positionY + 40, {
              height: height,
              width: col.w,
              align: 'center',
              lineBreak: false,
              ellipsis: true
            });
          });

          positionY += row === 0 ? 32 : height;
        };

        for (var row = 0; row <= persons.length + 1; row++) {
          _loop(row);
        }
      };

      var addPage = function addPage(scoresheet) {

        // FIXME - Donot repeat this logic elsewhere.
        var numRounds = scoresheet.event.rounds || (scoresheet.event.type === 'C' ? 3 : 1);
        doc.addPage();

        // Showing feisName
        doc.fontSize(headlineSize);
        doc.text('' + feisName, 250, 20);
        positionY = margin;

        // Showing ifeis logo
        doc.image(_this4.logo, 10, 10, { width: 60 });

        doc.fontSize(12);
        doc.text(scoresheet.event.description || '', margin, 60, {
          align: 'center',
          lineBreak: true,
          width: useablePageWidth,
          height: headlineSize,
          ellipsis: true
        });
        positionY += headlineSize + 30;

        doc.fontSize(11);
        // Adjudicator name
        doc.text('Judge\'s name: ' + scoresheet.adjudicator.fname + ' ' + scoresheet.adjudicator.lname, margin, 60, {
          align: 'right',
          width: useablePageWidth,
          lineBreak: true
        });

        var width = useablePageWidth;
        var height = 32;
        var numRows = scoresheet.scores.length + 1;
        var tableStartY = positionY;
        var tableEndY = tableStartY + ((scoresheet.scores.length - 1) * height + 32);
        var positionX = margin;
        var cols = [{
          valueToGet: 'competitor',
          label: 'Comp #',
          w: width * 0.1,
          align: 'center',
          fontSize: 11
        }, {
          valueToGet: 'competitorName',
          label: 'Competitor Name/\nSchool',
          w: width * 0.3,
          align: 'center',
          fontSize: 11
        }, {
          valueToGet: 'overallPlacement',
          label: 'Overall\nRanking',
          w: width * 0.1,
          align: 'center',
          fontSize: 11
        }, {
          valueToGet: 'overallIrishPoints',
          label: 'Overall\nIrish Points',
          w: width * 0.1,
          align: 'center',
          fontSize: 11
        }];

        if (numRounds === 1) {
          cols.push({
            valueToGet: 0,
            label: 'Round1',
            w: width * 0.1,
            align: 'center',
            fontSize: 11
          });
        } else {
          for (var row = 1; row <= numRounds; row++) {
            cols.push({
              valueToGet: row - 1,
              label: 'Round' + row,
              w: width * (0.2 / numRounds),
              align: 'center',
              fontSize: 11
            });
          }

          cols.push({
            valueToGet: 'total',
            label: 'Total',
            w: width * (0.2 / numRounds),
            align: 'center',
            fontSize: 11
          }, {
            valueToGet: 'computedTotal',
            label: 'Irish Points',
            w: width * 0.1,
            align: 'center',
            fontSize: 11
          });
        }

        // Calculate column starting positions
        cols.forEach(function (col) {
          col.x = positionX;
          positionX += col.w;
        });

        // Add end column line
        cols.push({ x: pageWidth - margin });

        doc.image(_this4.logo, 10, 10, { width: 60 });

        var _loop2 = function _loop2(_row) {
          // Draw row lines
          doc.moveTo(margin, positionY).lineTo(margin + width, positionY).stroke();

          var text = '';

          // Draw column lines
          cols.forEach(function (col) {
            doc.fontSize(col.fontSize || subheadSize);

            // Printing column labels. Since columns
            doc.text(col.label || '', col.x, tableStartY + (32 - subheadSize) / 2, {
              height: height,
              width: col.w,
              align: 'center',
              lineBreak: false,
              ellipsis: true
            });

            // Printing column values from data in each row
            if (_row < numRows - 1) {
              if (/Round/.test(col.label)) {
                text = scoresheet.scores[_row].scores[col.valueToGet].value;
              } else if (/competitorName/.test(col.valueToGet)) {
                text = scoresheet.scores[_row][col.valueToGet] + '\n' + scoresheet.scores[_row].schoolName.substring(0, 100);
              } else {
                text = col.valueToGet ? scoresheet.scores[_row][col.valueToGet] : '';
              }
            } else {
              // Stroking column lines on last row
              doc.moveTo(col.x, tableStartY + 32).lineTo(col.x, tableEndY + 32).stroke();
            }

            // Writing data to report for each column and each row
            doc.moveTo(col.x, tableStartY).lineTo(col.x, tableEndY).stroke().text(text, col.x, positionY + 40, {
              height: height,
              width: col.w,
              align: 'center',
              lineBreak: false,
              ellipsis: true
            });
          });

          positionY += _row === 0 ? 32 : height;
        };

        for (var _row = 0; _row <= numRows; _row++) {
          _loop2(_row);
        }
      };

      var addEndingSection = function addEndingSection() {
        doc.fontSize(8);
        doc.text('_________________________          _________________________', margin, positionY + 60, {
          align: 'center'
        });
        return doc;
      };

      this.isLoading = true;

      return this.fPrint.getLogo().then(function (logo) {
        _this4.logo = logo;
      }).then(function () {
        doc.y = 225;

        _this4.scoresheetsForSelected.forEach(function (scoresheet, idx) {
          if (idx > 0 && scoresheet.type === 'summary') {
            doc.addPage();
          }
          if (scoresheet.type === 'summary') {
            (function () {
              var scoresheetsForAnEvent = _this4.scoresheetsForSelected.filter(function (s) {
                return s.event.name === scoresheet.event.name && !s.type;
              });

              //Since we have already created scores array a combination of persons and their scores, we can use any item of scores array to
              // get object that we have created for participants.
              var personsArrayForAnEvent = scoresheetsForAnEvent.length > 0 ? scoresheetsForAnEvent[0].sortedScoresForSummary : [];
              var totalNumberOfRows = personsArrayForAnEvent.length;
              var numberOfTotalPagesRequired = Math.ceil(totalNumberOfRows / linesPerPage);
              var newPersonsToPrint = void 0;

              var _loop3 = function _loop3(indexOfPage) {
                newPersonsToPrint = personsArrayForAnEvent.slice(linesPerPage * indexOfPage, linesPerPage * (indexOfPage + 1));
                var newScoreSheet = [];
                scoresheetsForAnEvent.forEach(function (scoresheet, index) {
                  var scoresToPrint = scoresheetsForAnEvent[index].scores.slice(linesPerPage * indexOfPage, linesPerPage * (indexOfPage + 1));
                  var sortedScoresForSummaryToPrint = scoresheetsForAnEvent[index].sortedScoresForSummary.slice(linesPerPage * indexOfPage, linesPerPage * (indexOfPage + 1));
                  var newScoreSheetObj = _extends({}, scoresheetsForAnEvent[index]);
                  newScoreSheetObj.scores = scoresToPrint;
                  newScoreSheetObj.sortedScoresForSummary = sortedScoresForSummaryToPrint;
                  newScoreSheet.push(newScoreSheetObj);
                });
                addSummaryPage(scoresheet, newScoreSheet, newPersonsToPrint, indexOfPage);
              };

              for (var indexOfPage = 0; indexOfPage < numberOfTotalPagesRequired; indexOfPage++) {
                _loop3(indexOfPage);
              }

              addEndingSection();
            })();
          } else {
            var totalNumberOfRows = scoresheet.scores.length;
            var numberOfTotalPagesRequired = Math.ceil(totalNumberOfRows / linesPerPage);
            for (var indexOfPage = 0; indexOfPage < numberOfTotalPagesRequired; indexOfPage++) {
              var scoresToPrint = scoresheet.scores.slice(linesPerPage * indexOfPage, linesPerPage * (indexOfPage + 1));
              var _newScoreSheet = _extends({}, scoresheet);
              _newScoreSheet.scores = scoresToPrint;
              addPage(_newScoreSheet);
            }
            addEndingSection();
          }
        });
        return _this4.fPrint.download(doc);
      }).catch(function (e) {
        return _this4.msgService.displayErrorMsg(e.message || e.toString());
      }).finally(function () {
        // Cleanup regardless of success or failure
        _this4.isLoading = false;
        _this4.eventsWithResults.forEach(function (event) {
          return event.selectedItem = 0;
        });
        _this4.scoresheetsForSelected.length = 0;
        _this4.filter = [];
      });
    }
  }, {
    key: 'checkForAdjudicatorView',
    value: function checkForAdjudicatorView() {
      var _this5 = this;

      if (!this.reportSource && !this.adjudicators) {
        this.loading = true;
        this.$ngRedux.dispatch((0, _adjudicators.getFeisAdjudicators)(this.feis.id)).then(function (a) {
          _this5.loading = false;
          _this5.adjudicators = a.payload.sort(function (a, b) {
            return b.fname - a.fname;
          });
        }).catch(function (e) {
          _this5.msgService.displayErrorMsg(e.message || e.toString());
          _this5.isLoading = false;
        });
      }
    }
  }]);

  return JudgesReportsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.judges-reports', ['ifeis.printing']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.judges-reports', {
    url: '/judges-reports',
    template: require('./tpl.html'),
    controller: JudgesReportsController,
    controllerAs: 'ctrl',
    resolve: {
      events: function events($stateParams, fEventService) {
        return fEventService.for($stateParams.id);
      }
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/judges-reports/index.js
// module id = 564
// module chunks = 0